import Unsuccess from "../../../../shared/assets/icons/unsuccess.svg";
import { useAppSelector } from "../../../../shared/store";
import { VerificationForm } from "../../../../widgets/VerificationForm";
import styles from "./index.module.scss";

export const PaymentCancel = ({
  attachFile,
  descriptionText = true,
  cardNumber,
}: {
  attachFile: boolean;
  descriptionText?: boolean;
  cardNumber: boolean;
}) => {
  const offerData = useAppSelector((state) => state.payment.offer);

  const description = descriptionText ? (
    <div>
      <p>
        Если вы все же произвели оплату, обратитесь в техническую поддержку
        сайта.
      </p>
      <p
        style={{
          fontWeight: 700,
        }}
      >
        Если вы отправили неверную сумму, пожалуйста, свяжитесь с технической
        поддержкой.
      </p>
    </div>
  ) : (
    <></>
  );
  const title = "Заявка отменена";

  return (
    <>
      {offerData && (
        <VerificationForm
          cardNumber={cardNumber}
          icon={Unsuccess}
          title={title}
          description={description}
          orderNum={offerData ? String(offerData.humanId) : null}
          textBtn="Отправить чек"
          isSumFieldVisible={false}
          attachFile={attachFile}
          offerData={offerData}
        />
      )}

      <div className={styles.link_container}>
        {offerData && offerData.status === 12 && offerData.linkedOfferId && (
          <a
            className={styles.link}
            href={window.location.origin + "/" + offerData.linkedOfferId}
          >
            Вернуться к неоплаченной заявке
          </a>
        )}
      </div>
    </>
  );
};
